import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectUserActiveEmployerInfo } from 'store/user/selectors.js/user.selectors';
import { updateShadowProject } from '../services/updateShadowProject.service';

export const updateShadowProjectThunk = createAsyncThunk(
  'shadowData/updateShadowProject',
  async ({ shadowProjectId, updates }, { getState }) => {
    const activeEmployerInfo = selectUserActiveEmployerInfo(getState());

    const updatedShadowProject = await updateShadowProject(
      shadowProjectId,
      updates,
      activeEmployerInfo
    );

    return updatedShadowProject;
  }
);
